export default "__VITE_ASSET__65b16439__"